import { FC } from 'react';

export const MobileSpaceHeader: FC<{ description: string; name: string }> = ({
  description,
  name,
}) => (
  <div className="flex flex-col border-b border-gray-100 pb-4">
    <h2 className="truncate text-base font-semibold leading-8 text-gray-700">{name}</h2>
    {description && <p className="text-label-sm font-medium text-gray-500">{description}</p>}
  </div>
);
